module.exports = __webpack_public_path__ + "static/Ogre_Mage-2e70d490b43b47d1952ab72ba4f85d15.jpg";